import { FunctionComponent, useCallback } from 'react';

import { useCoreDispatch } from '../../../store/CoreStore';
import { chatActions } from '../../../store/slices/chat/slice';
import { ChatTabType } from '../../../store/slices/chat/types';
import { headerActions } from '../../../store/slices/header/slice';
import { toastActions, ToastsProps } from '../../../store/slices/toast/slice';
import { useIsLargerThanWide } from '../../../styles/hooks/media';
import { NavPages } from '../../nav/navPages/NavPagesConnected';
import { Toast } from '../../toast/Toast';

export const GameCanceledToastConnected: FunctionComponent<ToastsProps> = ({ msg, timeStamp, ...rest }) => {
  const dispatch = useCoreDispatch();
  const isWideScreen = useIsLargerThanWide();

  const closeFn = useCallback(() => {
    dispatch(toastActions.removeToast(timeStamp));
  }, [timeStamp]);
  const onBtnClick = (): void => {
    dispatch(headerActions.setNavRoute([]));
    dispatch(chatActions.setSelectedTab(ChatTabType.LiveSupportChat));
    dispatch(headerActions.pushNavRoute(NavPages.HOME));
    dispatch(headerActions.pushNavRoute(NavPages.CHAT));
    dispatch(chatActions.setIsChatClosed(false));

    if (isWideScreen) {
      dispatch(chatActions.setDisplayMiniChat(false));
    }

    closeFn();
  };

  const button = {
    tk: 'DETAILS',
    onClick: onBtnClick,
  };

  return <Toast message={msg} onClose={closeFn} button={button} {...rest} />;
};
